import { isViewportPreScaled } from './isViewportPreScaled';

export { isViewportPreScaled };
